module.exports = __webpack_public_path__ + "img/corriente_b.93d727a5.svg";